import {ModuleState} from '@fantasmagames/slot/src/common/ModuleState';
import {AutoplayMenuView} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuView';
import {AutoplayMenuModule} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuModule';
import {AutoplayMenuEvents} from '@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/AutoplayMenuEvents';

export class AutoplayMenuOpenState extends ModuleState<AutoplayMenuView, AutoplayMenuModule> {
	public onEnterState(): void {
		this.view.show();
		this.module.eventManager.emit(AutoplayMenuEvents.AUTO_PLAY_MENU_OPENED);
		//
	}

	public onLeaveState(): void {
		//
	}

	protected setupEvents(): void {
		//
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/slot/src/modules/popupmenus/autoplaymenu/states/AutoplayMenuOpenState.ts